<template>
  <sprite
    id="app/arrow"
    :class="`chevron-icon chevron-icon--${color} chevron-icon--${size} chevron-icon--${direction}`"
  />
</template>

<script>
import Sprite from "@/shared/sprite"

export default {
  name: "ChevronIcon",
  components: {
    Sprite
  },
  props: {
    color: {
      type: String,
      default: "blue"
    },
    size: {
      type: String,
      default: "s"
    },
    direction: {
      type: String,
      default: "bottom"
    }
  }
}
</script>

<style lang="scss" scoped>
.chevron-icon {
  display: inline-block;

  &--blue {
    color: $blue;
  }

  &--s {
    width: 12px;
    height: 12px;
  }

  &--top {
    transform: rotate(180deg);
  }

  &--left {
    transform: rotate(270deg);
  }

  &--right {
    transform: rotate(90deg);
  }

  &--bottom {
    transform: rotate(0deg);
  }
}
</style>
